export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10153.280f4ac4.jpg";